import { defaultPm2PrintChunkClassName } from '@provider/print';
import { printSplitComponent } from './printer.to-jsx.js';

const printSplitComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: printSplitComponent(node, context)
  }];
};
const splitComponentPaperPrinters = {
  "split-component": printSplitComponentPaper
};

export { splitComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
